<template>
  <div id="wrapper">
    <Nav :message="message" />
    <LeaverList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import LeaverList from '@/components/profile/LeaverList.vue'

export default {
  name: 'leaver',
  props: ['message'],
  components: {
    Nav,
    LeaverList
  }
}
</script>